import React from 'react'
import { useLocation, useNavigate } from 'react-router'
import { observer } from 'mobx-react-lite'

// evertel
import { Nav, NavItem, NavLink } from '@evertel/web/ui'

const TABS = [
    { label: 'Manage EverDocs', path: '/everdocs' },
    { label: 'Create a New Template', path: '/everdocs/schema/new' },
    { label: 'Template Categories', path: '/everdocs/schema/categories' }
]

const DocumentsTabs: React.FC = observer(() => {

    const location = useLocation()
    const navigate = useNavigate()

    const isActive = (path: string) => (path === '/everdocs')
        ? location.pathname === '/everdocs'
        : location.pathname.startsWith(path)

    return (
        <Nav
            variant="underline"
            role="tablist"
            className="mb-4">
            {TABS.map((tab) =>
                <NavItem key={tab.path}>
                    <NavLink
                        active={isActive(tab.path)}
                        onClick={() => navigate(tab.path)}>
                        {tab.label}
                    </NavLink>
                </NavItem>
            )}
        </Nav>
    )
})

export { DocumentsTabs }
